/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingplatforms1Inputs */

const en_crosspostingplatforms1 = /** @type {(inputs: Crosspostingplatforms1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platforms`)
};

const de_crosspostingplatforms1 = /** @type {(inputs: Crosspostingplatforms1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plattformen`)
};

/**
* | output |
* | --- |
* | "Platforms" |
*
* @param {Crosspostingplatforms1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingplatforms1 = /** @type {((inputs?: Crosspostingplatforms1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingplatforms1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingplatforms1(inputs)
	return de_crosspostingplatforms1(inputs)
});
export { crosspostingplatforms1 as "crosspostingPlatforms" }